class CartVolumeDiscount extends HTMLElement {
    constructor() {
        super();
        this.activeVolumeDiscountProgress = this.querySelector('.cart-volume-discount-progress:not(.hidden)')
        this.activeVolumeDiscountTable = this.parentElement.querySelector('.cart-list-volume-discounts-wrapper')
        this.money_format = (this.dataset.currencySymbol || '£') + '{{amount_with_comma_separator}}';

        if (window.publish !== undefined && window.subscribe !== undefined && PUB_SUB_EVENTS?.cartUpdate !== undefined) {
            this.cartUpdateUnsubscriber = window.subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
                this.onCartUpdate(e.cartData);
            });
        }
    }

    onCartUpdate(cartData) {
        let nextActiveVolumeDiscountProgress
        if (cartData && cartData.original_total_price) {
            // update progress bars and info text
            this.querySelectorAll('.cart-volume-discount-progress').forEach((progressElement) => {
                const progressBar = progressElement.querySelector('.cart-volume-discount-progress-bar')
                if (progressBar) {
                    progressBar.value = cartData.original_total_price;
                }
                const progressInfo = progressElement.querySelector('.cart-volume-discount-progress-info');
                const min = progressElement.dataset.min || 0;
                const max = progressElement.dataset.max || Infinity;
                const maxForRemainingAmount = progressElement.dataset.max || cartData.original_total_price;
                const infoText = (progressElement.dataset.info || '').replace('__placeholder_amount__', this.formatMoney(maxForRemainingAmount - cartData.original_total_price));
                if (progressInfo && infoText) {
                    progressInfo.textContent = infoText;
                }
                if (min <= cartData.original_total_price && max > cartData.original_total_price) {
                    nextActiveVolumeDiscountProgress = progressElement;
                }

            });
            if (nextActiveVolumeDiscountProgress.dataset.id !== this.activeVolumeDiscountProgress.dataset.id) {
                this.activeVolumeDiscountProgress.classList.add('hidden');
                nextActiveVolumeDiscountProgress.classList.remove('hidden');
                this.activeVolumeDiscountProgress = nextActiveVolumeDiscountProgress;
            }
        } else {
            this.activeVolumeDiscountProgress.classList.add('hidden');
            this.activeVolumeDiscountTable.classList.add('hidden');
        }
    }

    formatMoney = function(cents, format) {
        if (typeof cents == 'string') {
            cents = cents.replace('.','');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = (format || this.money_format);

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal   = defaultOption(decimal, '.');

            if (isNaN(number) || number == null) {
                return 0;
            }

            number = (number/100.0).toFixed(precision);

            var parts   = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents   = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch(formatString.match(placeholderRegex)[1]) {
            case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
            case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
            case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
            case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }

        return formatString.replace(placeholderRegex, value);
    };
}

customElements.define('cart-volume-discount', CartVolumeDiscount);